import {
  FETCH_ALGOS_REQUEST,
  FETCH_ALGOS_SUCCESS,
  FETCH_ALGOS_FAILURE,
  FETCH_ALGO_BY_ID_REQUEST,
  FETCH_ALGO_BY_ID_SUCCESS,
  FETCH_ALGO_BY_ID_FAILURE,
  FETCH_ALGO_CONFIG_REQUEST,
  FETCH_ALGO_CONFIG_SUCCESS,
  FETCH_ALGO_CONFIG_FAILURE,
} from '../../constants/ActionTypes';
import algoApi from '../../api/algo';
import { setUrlHash } from '../../utils';
import { dataCheck, getPrev } from '../../helpers/table-api';
import {
  isAlgosFetching,
  isAlgoByIdFetching,
  isAlgoConfigFetching,
} from '../getters/algos';

export const fetchAlgos = (id, pageNo) => async (dispatch, getState) => {
  if (isAlgosFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_ALGOS_REQUEST,
  });

  try {
    let data = await algoApi.getAlgos(id, pageNo);
    const check = dataCheck(data);
    const prev = getPrev(data);
    data = check ? data : await algoApi.getAlgos(id, prev);

    if (!check) {
      // Ghost page
      setUrlHash({
        tab: 'algos',
        page: prev,
      });
    }

    return dispatch({
      type: FETCH_ALGOS_SUCCESS,
      data: data,
    });
  } catch (error) {
    return dispatch({
      type: FETCH_ALGOS_FAILURE,
      data: error,
    });
  }
};

export const fetchAlgoById = (id, algoId) => (dispatch, getState) => {
  if (isAlgoByIdFetching(getState())) {
    return Promise.resolve();
  }

  dispatch({
    type: FETCH_ALGO_BY_ID_REQUEST,
  });

  return algoApi
    .getAlgoById(id, algoId)
    .then((data) => {
      return dispatch({
        type: FETCH_ALGO_BY_ID_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: FETCH_ALGO_BY_ID_FAILURE,
        data: error,
      });
    });
};

export const fetchAlgoConfig = () => async (dispatch, getState) => {
  try {
    if (isAlgoConfigFetching(getState())) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_ALGO_CONFIG_REQUEST,
    });

    const data = await algoApi.getAlgoConfig();

    dispatch({
      type: FETCH_ALGO_CONFIG_SUCCESS,
      data,
    });

    return Promise.resolve(data);
  } catch (error) {
    dispatch({
      type: FETCH_ALGO_CONFIG_FAILURE,
      data: error,
    });

    return Promise.reject(error);
  }
};
